import Container from '../../../../core/components/atoms/Container';
import PageHeader from '../../../../core/components/molecules/Header';
import InnerHTMLContainer from '../../../../core/components/molecules/InnerHTMLContainer';
import { Typography } from '../../../../core/components/molecules/Typography';
import { getDisciplineName } from '../../../../core/utils/discipline';

interface TextContentProps {
  content: any;
}

export default function TextContent({ content }: TextContentProps) {
  const title = content.value.split('</p>')[0].replace(/<\/?[^>]+(>|$)/g, '');
  const contentText = content.value.replace(title, '');
  return (
    <Container direction='col' gap='xxl'>
      <PageHeader title={title} module={getDisciplineName(content.area.slug)}>
        <div className='w-full flex flex-row justify-between items-center'>
          <Typography size='default'>Texto</Typography>
        </div>
      </PageHeader>
      <div className='md:w-full lg:w-[889px] m-auto'>
        <InnerHTMLContainer
          data={contentText}
          type='textContent'
          className='dark:text-mono-color-black'
        />
      </div>
    </Container>
  );
}
